<template>
<div>
  <navigation></navigation>
  <!--Main contents-->
  <div class="box_center" id="page_x">
    <h2 class="shadow" style="float: left">Manage Record</h2>
    <ul class="articles">
      <li v-for="record in records">
      <div class="article">
      <p class="text_article">{{record.pick}}&nbsp; &nbsp; <b>{{record.result}}</b></p>
          <b>{{record.date}}</b>
          <br>
          <a href="javascript;" @click.prevent="remove(record)">Delete</a>
          &nbsp; &nbsp;
          <a href="javascript;" @click.prevent="update(record, 'W')">Win</a>
          &nbsp; &nbsp;
          <a href="javascript;" @click.prevent="update(record, 'L')">Loss</a>
          &nbsp; &nbsp;
          </div>
      <div class="separator"></div>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
import Nav from '../components/Nav'
import RecordRepository from '../data/record.repository.js'
import _ from 'lodash'
export default {
  components: {
    'navigation': Nav
  },
  data () {
    return {
      total: 0,
      current: 0,
      page: 0,
      records: []
    }
  },
  created () {
    RecordRepository.get(this.page + 1).then((data) => {
      this.total = data.total
      this.current = data.to
      this.page = data.current_page
      this.records = data.data
    })
  },
  methods: {
    next () {
      if (this.current >= this.total && this.page !== 0) return
      RecordRepository.get(this.page + 1).then((data) => {
        this.total = data.total
        this.current = data.to
        this.page = data.current_page
        this.records = this.records.concat(data.data)
      })
    },
    remove (record) {
      RecordRepository.remove(record).then((result) => {
        let index = _.findIndex(this.records, record)
        this.records.splice(index, 1)
      }).catch(e => console.log(e))
    },
    update (record, result) {
      record.result = result
      RecordRepository.save(record).then((result) => {
        console.log('saved')
      }).catch(e => console.log(e))
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// ManageRecord.vue?4ff7169c